/* eslint-disable react/prop-types */
import React, { Fragment, useState } from 'react';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import T from 'i18n-react';
import {
  TableBody as MuiTableBody,
  TableRow as MuiTableRow,
  TableCell as MuiTableCell,
  Typography,
  IconButton,
  Collapse,
} from '@material-ui/core';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import TableCell from './TableCell';
import emptyList from '../../assets/img/empty_list.png';

import classes from './Table.module.scss';

const EXPAND_LAYOUT = 'expandLayout';

const TableBody = (props) => {
  const {
    data: {
      className,
      columnData,
      displayData,
      emptyRows,
      hover = true,
      keyColumn,
      tableData,
      positionExpand,
      usingExpandLayout,
    },
    func: { isSelected, handleClick, toolColumn },
    usingCheckbox,
    usingForFactoryAudit,
    customEmptyTableBody,
    defaultExpanded = false,
  } = props;

  const TableBodyItem = ({ n, idx }) => {
    const [isExpanded, setIsExpanded] = useState(defaultExpanded);

    return (
      <>
        <MuiTableRow
          hover={hover}
          onClick={handleClick(n)}
          aria-checked={isSelected(n[columnData[0].columnId])}
          tabIndex={-1}
          key={`${n[keyColumn]}_${idx}`}
          selected={
            usingCheckbox
              ? n[columnData[0].columnId] === true
              : isSelected(n[columnData[0].columnId])
          }
          classes={{ root: classes.row, selected: classes.selectedRow }}>
          {Object.keys(n).includes(EXPAND_LAYOUT) && positionExpand === 'left' && (
            <TableCell type='body'>
              {get(n, EXPAND_LAYOUT, null) && (
                <IconButton
                  aria-label='expand row'
                  size='small'
                  onClick={() => setIsExpanded(!isExpanded)}>
                  {isExpanded ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                </IconButton>
              )}
            </TableCell>
          )}
          {columnData.map((colData) => {
            const { columnId, width, render } = colData;
            return (
              <TableCell
                type='body'
                data={n}
                key={columnId}
                onClick={() => (usingExpandLayout ? setIsExpanded(!isExpanded) : {})}
                {...colData}>
                <div style={{ width: width || 'auto' }}>{render ? render(n) : n[columnId]}</div>
              </TableCell>
            );
          })}
          {toolColumn && <MuiTableCell>{toolColumn(n)}</MuiTableCell>}
          {Object.keys(n).includes(EXPAND_LAYOUT) && positionExpand === 'right' && (
            <TableCell type='body' width='2rem'>
              {get(n, EXPAND_LAYOUT, null) && (
                <IconButton
                  aria-label='expand row'
                  size='small'
                  onClick={() => setIsExpanded(!isExpanded)}>
                  {isExpanded ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                </IconButton>
              )}
            </TableCell>
          )}
        </MuiTableRow>
        {get(n, EXPAND_LAYOUT, null) && (
          <MuiTableRow classes={{ root: classes.root }}>
            <MuiTableCell style={{ padding: 0 }} colSpan={12}>
              <Collapse in={isExpanded} unmountOnExit>
                {n[EXPAND_LAYOUT]}
              </Collapse>
            </MuiTableCell>
          </MuiTableRow>
        )}
      </>
    );
  };

  return (
    <MuiTableBody className={className}>
      {tableData.length > 0 ? (
        <Fragment>
          {displayData.length > 0 ? (
            displayData.map((n, idx) => <TableBodyItem n={n} idx={idx} />)
          ) : (
            <MuiTableRow>
              {[...Array(Math.floor(columnData.length)).keys()].map((c) => (
                <MuiTableCell key={c} />
              ))}
            </MuiTableRow>
          )}
          {tableData.length > 0 && emptyRows > 0 && (
            <MuiTableRow style={{ height: 49 * emptyRows }}>
              <MuiTableCell colSpan={columnData.length} />
            </MuiTableRow>
          )}
        </Fragment>
      ) : (
        <MuiTableRow>
          <MuiTableCell style={{ border: 'none' }} colSpan={columnData.length} align='center'>
            {usingForFactoryAudit ? (
              <>
                <img src={emptyList} alt='Empty list' />
                <Typography className={classes.text}>
                  To audit your factory, start requesting for a new quote.
                </Typography>
              </>
            ) : (
              customEmptyTableBody || T.translate('general.noData')
            )}
          </MuiTableCell>
        </MuiTableRow>
      )}
    </MuiTableBody>
  );
};

TableBody.defaultProps = {
  columnData: [],
  displayData: [],
  emptyRows: 0,
  keyColumn: '',
  tableData: [],
  isSelected: null,
  handleClick: null,
  toolColumn: null,
};

TableBody.propTypes = {
  columnData: PropTypes.arrayOf(PropTypes.object),
  data: PropTypes.object.isRequired,
  displayData: PropTypes.arrayOf(PropTypes.object),
  emptyRows: PropTypes.number,
  func: PropTypes.object.isRequired,
  keyColumn: PropTypes.string,
  tableData: PropTypes.arrayOf(PropTypes.object),
  isSelected: PropTypes.func,
  handleClick: PropTypes.func,
  toolColumn: PropTypes.func,
};

export default TableBody;
